import { render, staticRenderFns } from "./ProductAnalysesSkeleton.vue?vue&type=template&id=d91982a0&scoped=true&"
import script from "./ProductAnalysesSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ProductAnalysesSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAnalysesSkeleton.vue?vue&type=style&index=0&id=d91982a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91982a0",
  null
  
)

export default component.exports